export enum DisputeStatus {
    All = 0,
    Received = 1,
    InReview = 2,
    Closed = 3,
    VendorReview = 4,
    FinalReview = 5,
}

export const DisputeStatusText: Record<DisputeStatus, string> = {
    [DisputeStatus.All]: "All",
    [DisputeStatus.Received]: "Received",
    [DisputeStatus.InReview]: "In Review",
    [DisputeStatus.Closed]: "Closed",
    [DisputeStatus.VendorReview]: "Vendor Review",
    [DisputeStatus.FinalReview]: "Final Review",
};